module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_5-f5a4768b96f27daa4baa161ceb0630ea.gif";